"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  learnRecord: {
    testResults: 'Test Results',
    learningTasks: 'Learning Tasks',
    workTasks: 'Work Tasks',
    taskType: 'Task Type',
    myTaskQuery: 'My Task Query',
    startTest: 'Do you want to start the exam',
    verifFile: 'Please supplement the attachment first',
    verifTest: 'Please complete the exam first',
    learnDetail: {
      post: 'Post',
      learnDeatil: 'learning Situation',
      studyDate: 'Study Date',
      name: 'Name',
      learningSituation: 'Learning Situation'
    }
  }
};